import React from 'react';
import cn from 'classnames';

import { AnimatedCarouselMode } from './animatedCarouselMode';
import styles from './_AnimatedCarouselItem.module.css';

interface AnimatedCarouselItemProps {
    mode: AnimatedCarouselMode;
    activeChild: React.ReactNode;
    defaultChild: React.ReactNode;
    onClick(): void;
}

const ACTIVE_MODES: AnimatedCarouselMode[] = ['active', 'activeInPlace', 'activeShiftedRight'];

export const AnimatedCarouselItem: React.FC<AnimatedCarouselItemProps> = (props) => {
    const { mode, onClick, activeChild, defaultChild } = props;

    const isActive = ACTIVE_MODES.includes(mode);

    const handleKeyDown = (event: React.KeyboardEvent<HTMLLIElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick();
        }
    };

    return (
        <li
            className={cn(styles.item, {
                [styles.itemActive]: mode === 'active',
                [styles.itemActiveInPlace]: mode === 'activeInPlace',
                [styles.itemActiveShiftedRight]: mode === 'activeShiftedRight',
                [styles.itemTranslatedDefault]: mode === 'translatedDefault',
                [styles.itemShiftedRight]: mode === 'shiftedRight',
            })}
            tabIndex={isActive ? -1 : 0}
            role={isActive ? undefined : 'button'}
            onClick={isActive ? undefined : onClick}
            onKeyDown={isActive ? undefined : handleKeyDown}
        >
            <div className={styles.defaultElement}>{defaultChild}</div>
            <div className={styles.activeElement}>{activeChild}</div>
        </li>
    );
};
